import React from "react";
import { StyleSheet } from "react-native";
import * as Animatable from "react-native-animatable";
import { useEffect } from "react";
import { useState } from "react";
import theme from "app/Theme/Theme";
import { Box } from "app/components/common";
import normalize from "app/utils/normalize";
import getRandomIntInclusive from "app/utils/getRandomIntInclusive";

const WIDTH_BAR = normalize(4);
const MARGIN_BAR = normalize(3);

const MAX_BAR_HEIGHT = normalize(20);
const MIN_BAR_HEIGHT = normalize(4);

const styles = StyleSheet.create({
  dot: {
    width: WIDTH_BAR,
    marginRight: MARGIN_BAR,
    borderRadius: 5,
    backgroundColor: theme.colors["neutral.white"],
    overflow: "visible",
  },
});

interface Props {
  hasDarkBackground?: boolean;
}

const AudioRecordingBar = ({ hasDarkBackground = false }: Props) => {
  const [dots, setDots] = useState<number[]>([]);
  const [dotsMaxLength, setDotsMaxLength] = useState(0);

  const handleLayoutDots = event => {
    const { width } = event.nativeEvent.layout;
    const dotLength = WIDTH_BAR + MARGIN_BAR;

    setDotsMaxLength(width / dotLength);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevState => {
        if (prevState.length >= dotsMaxLength && dotsMaxLength) {
          const newDots = [...prevState];
          newDots.shift();
          newDots.push(
            normalize(getRandomIntInclusive(MIN_BAR_HEIGHT, MAX_BAR_HEIGHT)),
          );
          return newDots;
        } else {
          return [
            ...prevState,
            normalize(getRandomIntInclusive(MIN_BAR_HEIGHT, MAX_BAR_HEIGHT)),
          ];
        }
      });
    }, 150);

    return () => clearInterval(interval);
  }, [dotsMaxLength]);

  return (
    <Box
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="row"
      width="80%"
    >
      <Box
        width="100%"
        overflow="hidden"
        flexDirection="row"
        height={MAX_BAR_HEIGHT}
        justifyContent="flex-start"
        alignItems="center"
        marginRight="s"
        onLayout={handleLayoutDots}
      >
        {dots.map((el, index) => {
          return (
            <Animatable.View
              key={index}
              style={[
                styles.dot,
                {
                  backgroundColor: hasDarkBackground
                    ? theme.colors["system.red.900"]
                    : theme.colors["neutral.white"],
                  height: el,
                },
              ]}
              animation="fadeIn"
              useNativeDriver={true}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default AudioRecordingBar;
